import React from 'react';
import { handleException } from '../../helper/helperError';
import { apiGet } from '../../helper/helperApi'; // Assuming you have this helper
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Filler,
} from 'chart.js';
import ComLoading from './comLoading';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Filler
);

const ChartEmailVolumeLTM = () => {
    const [chartData, setChartData] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        setIsLoading(true);
        apiGet('/reports/getChartEmailVolumeLTM')
            .then(response => {
                setChartData(response?.data || []);
            })
            .catch(ex => {
                handleException(ex, "Failed to fetch LTM email volume");
                setChartData([]);
            })
            .finally(() => setIsLoading(false));
    }, []);

    if (isLoading) {
        return (
            <div className="card shadow-sm h-100">
                <div className="card-header bg-white border-0"><h5 className="card-title mb-0">Email Volume (Last 12 Months)</h5></div>
                {/* We can use your existing ComLoading component */}
                <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '340px' }}>
                    <ComLoading message="Loading email volume data..." />
                </div>
            </div>
        );
    }

    const data = {
        labels: chartData.map(d => d.month),
        datasets: [
            {
                label: 'Successful',
                data: chartData.map(d => d.successful),
                borderColor: '#198754',
                backgroundColor: 'rgba(25, 135, 84, 0.1)',
                fill: true,
                tension: 0.4,
            },
            {
                label: 'Failed',
                data: chartData.map(d => d.failed),
                borderColor: '#dc3545',
                backgroundColor: 'rgba(220, 53, 69, 0.1)',
                fill: true,
                tension: 0.4,
            },
            {
                label: 'Total Processed',
                data: chartData.map(d => d.processed),
                borderColor: '#0d6efd',
                backgroundColor: 'rgba(13, 110, 253, 0.1)',
                fill: false,
                tension: 0.4,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        // --- ANIMATION CONFIGURATION ADDED HERE ---
        animation: {
            duration: 1500, // Total animation time in milliseconds
            easing: 'easeInOutQuad', // A smooth easing function
            // The delay function creates the "drawing" effect
            delay: (context) => {
                let delay = 0;
                // We only want to animate the main data points
                if (context.type === 'data' && context.mode === 'default') {
                    // The delay is staggered based on the data point's index,
                    // creating a left-to-right "drawing" motion.
                    delay = context.dataIndex * 75 + context.datasetIndex * 200;
                }
                return delay;
            },
        },
        plugins: {
            legend: {
                position: 'top',
                align: 'end',
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        if (value >= 1000) {
                            return (value / 1000) + 'k';
                        }
                        return value;
                    }
                }
            }
        },
        interaction: {
            mode: 'index',
            intersect: false,
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-header bg-white border-0"><h5 className="card-title mb-0">Email Volume (Last 12 Months)</h5></div>
            <div className="card-body">
                <div style={{ height: '300px' }}>
                    <Line options={options} data={data} />
                </div>
            </div>
        </div>
    );
};

export default ChartEmailVolumeLTM;